/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cost_QuestionInputs */

const en_faq_cost_question = /** @type {(inputs: Faq_Cost_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long will it take, and what will it cost?`)
};

const lv_faq_cost_question = /** @type {(inputs: Faq_Cost_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cik ilgi tas prasīs un cik tas maksās?`)
};

/**
* | output |
* | --- |
* | "How long will it take, and what will it cost?" |
*
* @param {Faq_Cost_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_cost_question = /** @type {((inputs?: Faq_Cost_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cost_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_cost_question(inputs)
	return en_faq_cost_question(inputs)
});